import { createTheme } from './utils'

const theme = createTheme()

export default theme
